import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { migrateLegacyPortalPath } from "../lib/portalPaths";

/** /portal/… → /{client-slug}/… for bookmarks and old notification links. */
export function PortalLegacyRedirect() {
  const { client } = useAuth();
  const location = useLocation();
  if (!client) return <Navigate to="/admin" replace />;
  const target = migrateLegacyPortalPath(`${location.pathname}${location.search || ""}`, client);
  return <Navigate to={target} replace />;
}
